import DataGrid2 from '../../..';

export async function deleteRows(this: DataGrid2, ids: any[] = []) {
	if (ids.length) {
		const keyExpr = this.getUniqueDataField();

		await this.set(
			'rows',
			this.rows.filter(row => !ids.includes(row.data[keyExpr]))
		);
	}
}
